<template>
  <GoogleMapLoader
    :mapConfig="mapConfig"
    apiKey="AIzaSyCBSPp1PzEAqP35WskqYgTct-FRgJf8Vbk"
    :bondMarkers="markers"
    :language="mapLang"
  >
  // insert your google maps api key to render styled map
    <template slot-scope="{ google, map }">
      <GoogleMapMarker
        v-for="marker in markers"
        :key="marker.id"
        :marker="marker"
        :google="google"
        :map="map"
      />
    </template>
  </GoogleMapLoader>
</template>

<script>
import GoogleMapLoader from "./GoogleMapLoader";
import GoogleMapMarker from "./GoogleMapMarker";

import { mapSettings } from "@/constants/mapSettings";

export default {
  components: {
    GoogleMapLoader,
    GoogleMapMarker
  },

  props: [
    'markers'
  ],

  computed: {
    mapConfig() {
      return {
        ...mapSettings,
        center: this.mapCenter
      };
    },

    mapCenter() { 
      return this.markers[0].position;
    },
    
    mapLang(){
      if(this.$route.query.lang=='fr-CA'){
        return 'fr-CA';
      } else {
        return 'en';
      }       
    }
  }
};
</script>
